import React from 'react'
import { ComponentPropsWithRef } from 'react'
import { twMerge } from 'tailwind-merge'
import { useCtxParams } from '../../../context/useCommonCtx'
import { useTheme } from '@mui/material'

type Props = ComponentPropsWithRef<'button'>
export const RButton = (p: Props) => {
    const { className, disabled = false, ...rest } = p
    const params = useCtxParams();
    const muiTheme = useTheme();
    return (
        <button
            title={p.title}
            className={twMerge(
                className,
                `px-4 py-2 border rounded-lg`,
                disabled ? 'opacity-50 cursor-not-allowed' : `hover:brightness-90`
            )}
            disabled={disabled}
            {...rest}
            style={{
                backgroundColor: muiTheme.palette.secondary.main,
                color: muiTheme.palette.secondary.contrastText,
                // Disable iOS tap highlight being stuck after first tap
                WebkitTapHighlightColor: 'transparent',
                outline: 'none',
            }}
        >
            {p.children}
        </button>
    )
}
